import React from 'react';
import { Route, Switch } from 'react-router-dom';

// PAGES
import CargaHorariaList from './CargaHorariaList';
import CargaHorariaNew from './CargaHorariaNew';
import CargaHorariaView from './CargaHorariaView';

function CargaHoraria(props) {
    const { match } = props;

    return (
        <Switch>
            <Route path={match.path} exact component={CargaHorariaList} />
            <Route path={`${match.path}/new`} exact component={CargaHorariaNew} />
            <Route path={`${match.path}/:cod`} component={CargaHorariaView} />
            
        </Switch>
    )
}

export default CargaHoraria;
